import { createMarkup } from "../../../utils/helperServices";
import DropDown from "../newLineForms/dropDown/DropDown";
import styles from "./FaqItem.module.scss";

export const FaqItem = ({
  item,
  selectedFaqIndex,
  selectedFaqId,
  onChangeHandler,
  onResetHandler,
}) => {
  return (
    <div className={styles["container"]}>
      <div className={styles["heading"]}>
        <img className={styles["icon"]} src={item.icon} />
        <span
          className={styles["label"]}
          id={item.quesId ? item.quesId : item.id}
        >
          {item.title}
        </span>
      </div>
      {item.faqOptions ? (
        <>
          <div className={`${styles["select-row"]}`}>
            <div className={`${styles["select-group"]}`}>
              <DropDown
                label="Application process"
                name={`faqSelect-${item.id}`}
                data={item.faqOptions}
                handleSelect={onChangeHandler}
                handleReset={onResetHandler}
                resetRequired={true}
                selectedId={selectedFaqId}
                customId={`checkout-faq-select-${item.id}`}
              />
            </div>
          </div>
          <div className={`${styles["desc"]} ${styles["select-desc"]}`}>
            <span
              dangerouslySetInnerHTML={createMarkup(
                item.faqOptions[selectedFaqIndex]?.description
              )}
            ></span>
          </div>
        </>
      ) : (
        <div className={styles["desc"]}>
          <span dangerouslySetInnerHTML={createMarkup(item.description)}></span>
        </div>
      )}
    </div>
  );
};

export default FaqItem;
